import React, { useEffect, useRef } from "react";
import styled, { useTheme } from "styled-components";
import { colors } from "../../Assets/styles/colors";

import { ReactComponent as SentIcon } from "../../Assets/iconsv2/chat/UncheckedMessage.svg";
import { ReactComponent as ProcessingIcon } from "../../Assets/iconsv2/chat/CheckedMessage.svg";
import { ReactComponent as TranslatedIcont } from "../../Assets/iconsv2/chat/CheckedMessage.svg";

import { ReactComponent as ForwardedIcon } from "../../Assets/icons/forwardIcon.svg";

import { useTranslate } from '@tolgee/react';
import Linkify from "linkify-react";
import ReplymessageElement from "./ReplyMessageElement";

import "@vidstack/react/player/styles/default/theme.css";
import "@vidstack/react/player/styles/default/layouts/video.css";
import FileMessageComponent from "./FileMessageComponent";
import { useAuthService } from "../../Context/AuthContext";
import { findTranslatedTextForUser } from "../../Helpers/chatHelper/ChatHelper";
import { useGenericComponentsStateService } from "../../Context/GenericComponentsStateContext";
import ReactionsContainer from "./ReactionsContainer";

const Message = ({
  text,
  sentTime,
  status,
  image,
  reactions,
  messageId,
  conversationId,
  handleShowFullScreenImg,
  messageDeleted,
  displayRightClickMenu,
  isMessageRead,
  messageObject,
  forwarded,
  messageParent,
  file,
  video,
  onScroll,
  quickChat,
  qcUser,
  otherParticipants,
}) => {
  let imageHeight;
  let imageWidth = 350;
  const longPressTimeout = useRef(null);
  const { automaticTranslations } = useGenericComponentsStateService();
  const { user } = useAuthService();
  const theme = useTheme();

  const scaledHeightForMaxWidth = (scale) => {
    let aspectRatio = parseFloat(image.width) / parseFloat(image.height);
    let newHeight = scale / aspectRatio;
    return parseFloat(newHeight);
  };

  const scaledwidthForHeight = (scaledWidth) => {
    let aspectRatio = parseFloat(image.height) / parseFloat(image.width);
    let newWidth = scaledWidth / aspectRatio;
    return parseFloat(newWidth);
  };

  var details;

  switch (status) {
    case "sent":
      details = (
        <Details>
          <SendTime>
            <p>{sentTime}</p>
          </SendTime>
          <Status isread={isMessageRead}>
            <SentIcon />
          </Status>
        </Details>
      );
      break;

    case "processing":
      details = (
        <Details>
          <SendTime>
            <p>{sentTime}</p>
          </SendTime>
          <Status style={{ color: theme.chat.sentTime }}>
            <ProcessingIcon />
          </Status>
        </Details>
      );
      break;

    case "translated":
      details = (
        <Details>
          <SendTime>
            <p>{!messageDeleted && sentTime}</p>
          </SendTime>
          <Status isread={isMessageRead}>
            <TranslatedIcont />
          </Status>
        </Details>
      );
      break;
    default:
      break;
  }

  if (image) {
    if (window.innerWidth < 990) {
      imageHeight = scaledHeightForMaxWidth(300);
    } else {
      imageHeight = scaledHeightForMaxWidth(400);
    }
    imageWidth = scaledwidthForHeight(imageHeight);
  }

  //MOBILE touch context menu
  const handleTouchStart = (e) => {
    const touch = e.touches[0];
    e.preventDefault();
    longPressTimeout.current = setTimeout(() => {
      displayRightClickMenu(e, messageId, conversationId, messageObject);
    }, 500); // 800 ms for long press detection
  };

  const handleTouchEnd = () => {
    clearTimeout(longPressTimeout.current);
  };

  const displayMessageTranslations = (messageTranslations) => {
    let uniqueTranslations = new Map();
    messageTranslations.forEach((item) => {
      if (
        item.translation_language !== null &&
        item.translation_language !== user.language &&
        item.translation !== ""
      ) {
        if (!uniqueTranslations.has(item.translation_language)) {
          uniqueTranslations.set(item.translation_language, item);
        }
      }
    });

    return Array.from(uniqueTranslations.values());
  };
  const { t } = useTranslate();
  return (
    <Container onScroll={onScroll}>
      <MessageWrapper
        onContextMenu={(e) =>
          displayRightClickMenu(e, messageId, conversationId, messageObject)
        }
        onTouchStart={(e) => handleTouchStart(e)}
        onTouchEnd={handleTouchEnd}
        imgcontainer={image || video}
      >
        <ItemWrapper>
          {forwarded && (
            <ForwardedInfo image={image || video}>
              <ForwardedIcon />
              <p>Forwarded</p>
            </ForwardedInfo>
          )}

          {messageParent && !messageDeleted && (user || qcUser) && (
            <ReplymessageElement
              text={quickChat ? findTranslatedTextForUser(
                messageParent.message_translations,
                qcUser
              )?.translation
                :
                findTranslatedTextForUser(
                  messageParent.message_translations,
                  user
                )?.translation
              }
              image={messageParent.image}
              messageDeleted={messageParent.deleted}
              sender={messageParent.user?.name}
              file={messageParent.document}
              video={messageParent.video}
            />
          )}
          {file && <FileMessageComponent file={file} />}

          {image && (
            <ImageWrappr>
              <img
                height={imageHeight}
                width={imageWidth}
                src={image.url}
                alt="pht"
                onClick={() =>
                  handleShowFullScreenImg(image.url, messageId, conversationId)
                }
              />
            </ImageWrappr>
          )}
          {video && (
            <VideoPreview>
              <video src={video.video_url} width={"100%"} controls></video>
            </VideoPreview>
          )}
          {text.length > 0 && (
            <TextWrapper image={image || video}>
              <Linkify options={{ target: "_blank" }}>
                <p>
                  {!messageDeleted ? (
                    text
                  ) : (
                    <i>{t('chat.message_deleted')}</i>
                  )}
                </p>
              </Linkify>
            </TextWrapper>
          )}

          {messageDeleted && (
            <h3>
              <i>{t('chat.message_deleted')}</i>
            </h3>
          )}

          {!quickChat &&
            displayMessageTranslations(messageObject.message_translations)
              .length > 0 &&
            automaticTranslations && (
              <MessageTranslationsWrapper image={image || video}>
                {displayMessageTranslations(
                  messageObject.message_translations
                ).map((item, index) => (
                  <MessageTranslation key={index}>
                    <MessageTranslationLanguage>
                      {item.translation_language}:{" "}
                    </MessageTranslationLanguage>
                    {item.translation}
                  </MessageTranslation>
                ))}
              </MessageTranslationsWrapper>
            )}
        </ItemWrapper>

        {reactions[0] && !messageDeleted && (
          <ReactionsContainer
            reactions={reactions}
            participants={otherParticipants}
            adjustmentForSide={true}
          />
        )}
      </MessageWrapper>
      {!messageDeleted && details}
    </Container>
  );
};

export default Message;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 20px;
  gap: 7px;
`;
const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
const MessageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  margin-left: auto;
  gap: 10px;
  width: fit-content;
  max-width: 80%;
  background: ${({ theme }) => theme.chat.sentMessageBackground};
  padding: ${(props) => (props.imgcontainer ? "4px" : "16px")};
  border-top-left-radius: ${(props) => (props.imgcontainer ? "4px" : "20px")};
  border-bottom-left-radius: ${(props) =>
    props.imgcontainer ? "4px" : "20px"};
  border-top-right-radius: ${(props) => (props.imgcontainer ? "4px" : "8px")};
  border-bottom-right-radius: ${(props) =>
    props.imgcontainer ? "4px" : "20px"};

  a {
    color: ${({ theme }) => theme.chat.sentMessageTextColor};
  }

  h3 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: pre-wrap;
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    color: ${({ theme }) => theme.chat.sentMessageTextColor};
    padding: 0 5px;
  }
`;
const Details = styled.div`
  display: flex;
  gap: 5px;
  margin-left: auto;
  width: fit-content;
`;
const Status = styled.div`
  display: flex;
  align-items: center;
  height: 16px;
  width: 16px;

  svg {
    color: ${({ isread, theme }) =>
    isread ? theme.chat.readIconColor : theme.chat.sentTime};
    height: 100%;
    width: 100%;
  }
`;
const SendTime = styled.div`
  display: flex;
  align-items: center;
  p {
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    text-align: right;
    color: ${({ theme }) => theme.chat.sentTime};
  }
`;
const ForwardedInfo = styled.div`
  display: flex;
  gap: 3px;
  align-items: center;
  margin-top: ${(props) => (props.image ? "6px" : "")};
  padding: ${(props) => (props.image ? "0 8px" : "")};
  p {
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    text-align: left;
    color: ${({ theme }) => theme.chat.sentMessageTextColor};
  }
  svg {
    max-height: 12px;
  }
`;
const ImageWrappr = styled.div`
  display: flex;

  img {
    display: flex;
    width: auto;
    max-width: 100%;
    cursor: pointer;
  }
`;

const VideoPreview = styled.div`
  .vds-time {
    display: none;
  }
`;
const TextWrapper = styled.div`
  padding: ${(props) => (props.image ? "5px 8px" : "")};
  display: flex;

  p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: pre-wrap;
    word-break: break-word;
    font-size: 16px;
    font-weight: 400;
    line-height: 19px;
    text-align: left;
    color: ${({ theme }) => theme.chat.sentMessageTextColor};
  }

  i {
    font-size: 14px;
    padding: 0 5px;
  }
`;

const MessageTranslationsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  border-top: 1px solid
    ${({ theme }) => theme.chat.translationMessageBorderColor};

  width: 100%;
  oveflow: hidden;
  padding: ${(props) => (props.image ? "5px 8px" : "10px 0 0 0")};
`;
const MessageTranslation = styled.p`
  font-weight: 400;
  font-size: 15px;
  line-height: 17px;
  letter-spacing: 0px;
  vertical-align: middle;
  color: ${({ theme }) => theme.chat.translationMessageTextColor};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  word-break: break-word;
`;

const MessageTranslationLanguage = styled.span`
  font-weight: 600;
`;
